// extracted by mini-css-extract-plugin
module.exports = {"row":"TableLoader_row__zdGij","disableScroll":"TableLoader_disableScroll__2ffpB"};